import React from 'react';
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import FolderSpecialIcon from '@material-ui/icons/FolderSpecial';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { StructMapData } from 'components/struct-map/struct-map-types';
import { FileFormat } from '../struct-map-file-format';
import { prettyPrintFileSize } from '../utils';
import { ArchivalUnitCopy } from '../../../types';

export const nodeLabelMapper = (
  data: StructMapData,
  parentEntity: ArchivalUnitCopy,
  isOpen: boolean
) => (
  <>
    {!!data.subDivisions?.length ? (
      <>
        {!isOpen ? (
          <>
            <ChevronRightIcon />
            <FolderOpenIcon fontSize={'small'} style={{ marginRight: 10 }} />
          </>
        ) : (
          <>
            <ExpandMoreIcon />
            <FolderIcon fontSize={'small'} style={{ marginRight: 10 }} />
          </>
        )}
      </>
    ) : (
      <>
        <div style={{ width: 25, height: 25 }} />
        {/* icon placeholder */}
        <FolderSpecialIcon fontSize={'small'} style={{ marginRight: 10 }} />
      </>
    )}
    <span>{data.label}</span>
    {parentEntity?.archivalUnitReference?.evidenceTypeName && (
      <span>{`(${parentEntity.archivalUnitReference.evidenceTypeName})`}</span>
    )}
  </>
);

export const leafLabelMapper = (data: StructMapData) => (
  <>
    <FileFormat contentType={data.fileRef!.contentType} />
    {data.subDivisions ? data.aisId : data.label}
    {`(${prettyPrintFileSize(data.fileRef?.size)} MB)`}
  </>
);
